import { getConnectors } from '@/features/AudienceManager/services';
export const fetchListConnectors = () => getConnectors().then(response => formatValue(response?.data));
const formatValue = (response) => {
    return {
        data: response.data
            .filter(connector => connector.type !== 'I')
            .map(connector => ({
            alias: connector.alias,
            id: connector.id,
            name: connector.name,
            enabled: false,
            interval: 0,
            hasDatetime: false,
            instance: undefined,
            config: [],
            startDatetime: '',
            title: '',
            scheduleId: null,
            lastExecution: null,
            editable: false,
            status: null,
        })),
        errors: response.errors,
        success: response.success,
    };
};
